module.exports = __webpack_public_path__ + "static/img/wear_detect2.2638ae9.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/air_2020/wear_detect2.gif
// module id = IMHt
// module chunks = 1